<script setup>
import { computed } from 'vue';

import {
    formataMoedaReais,
    formataDataHoraFromDb,
    formataCpf,
    formataTelefone,
} from '@kodatec/brasil-utils';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    },
    rubricaDetalhamento: {
        type: Object,
        required: false
    }
})

const saldoRubrica = computed(() => {
    const saldo = props.rubricaDetalhamento?.saldo;
    return saldo == null ? null : saldo;
});

const totalRubrica = computed(() => {
    const valorUnitario = props.rubricaDetalhamento?.valor_unitario;
    const quantidade = props.rubricaDetalhamento?.quantidade;
    if (valorUnitario == null || quantidade == null) {
        return null;
    }
    return Number(valorUnitario) * Number(quantidade);
});

const gastoRubrica = computed(() => {
    const gasto = props.rubricaDetalhamento?.gasto;
    return gasto == null ? null : gasto;
});

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Informações Gerais</h3>

    <LabelDados :titulo="'Solicitante'" :conteudo="solicitacao.nome"
        :detalhe="`CPF: ${formataCpf(solicitacao.cpf, false)}`" />

    <LabelDados titulo="Contatos" :conteudo="solicitacao.email ? solicitacao.email : solicitacao.telefone"
        :detalhe="solicitacao.email ? `Telefone: ${formataTelefone(solicitacao.telefone)}` : ''" />

    <LabelDados v-if="solicitacao.data_solicitacao" :titulo="'Data de solicitação'"
        :conteudo="`${formataDataHoraFromDb(solicitacao.data_solicitacao)}`" />

    <LabelDados v-if="solicitacao.rubrica_codigo" :titulo="'Rubrica Financeira'"
        :conteudo="`${solicitacao.rubrica_codigo} - ${solicitacao.rubrica_nome}`">
        <template #detalhe>
            <p class="text-500 text-xs mt-1 m-0" v-if="solicitacao.rubrica_detalhe_descricao">Detalhe: {{ solicitacao.rubrica_detalhe_descricao }}</p>
            <p class="text-500 text-xs mt-1 m-0" v-if="Number.isFinite(totalRubrica)">Total: {{ formataMoedaReais(totalRubrica) }}</p>
            <p class="text-500 text-xs mt-1 m-0" v-if="Number.isFinite(gastoRubrica)">Gasto: {{ formataMoedaReais(gastoRubrica) }}</p>
            <p class="text-500 text-xs mt-1 m-0" v-if="Number.isFinite(saldoRubrica)">Saldo: {{ formataMoedaReais(saldoRubrica) }}</p>
        </template>
    </LabelDados>

    <LabelDados v-if="solicitacao.subrubrica_nome" :titulo="'Subrubricas'" :conteudo="`${solicitacao.subrubrica_nome}`"
        :detalhe="`Código ${solicitacao.subrubrica_codigo}`" />

    <LabelDados v-if="solicitacao.meta_id" :titulo="'Meta'" :conteudo="`${solicitacao.meta}`" :tamanho_div="'col-12'" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">
</template>